var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoqStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1856 820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-New_Alipurduar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 820
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Alipurduar",
    "data-name": "New Alipurduar",
    clipPath: "url(#clip-New_Alipurduar)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1856,
    height: 820
  }), /*#__PURE__*/React.createElement("g", {
    id: "YardLayout",
    "data-name": "Yard Layout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TNG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER2Line",
    d: "M-2.9,60.9h21.5L74.616-1.174h16.24",
    transform: "translate(654.479 178.674)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER1Line",
    d: "M-12.171,0H2.382L61.509,53.291h12.17",
    transform: "translate(956.224 182.243)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER3Line",
    d: "M0,0H13.9L66.771,74.548h16.8",
    transform: "translate(1215.5 244.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER4Line",
    d: "M0,0H10.034L95.788,50.4h12.3",
    transform: "translate(1303.434 328.554)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER5Line",
    d: "M115.582,0h-12.3L4.153,73.781H-9.178",
    transform: "translate(533.5 244.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER6Line",
    d: "M-4.154,0H13.113L86.52,55.183h18.61",
    transform: "translate(485.773 388.317)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER7Line",
    d: "M51,0H41.665L4.771,55H-5.737",
    transform: "translate(965.5 388.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER8Line",
    d: "M79,0H67.546L11.454,54.872H.522",
    transform: "translate(880.767 452.838)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER9Line",
    d: "M123.089,0H105.014L18.71,112.436H2.366",
    transform: "translate(955.78 453.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER10Line",
    d: "M34.342,0,2.168,53.357H-10.721",
    transform: "translate(935.158 574.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TCTONGUER11Line",
    d: "M53.038.505H44.316L9.38,52H0",
    transform: "translate(468.5 327.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine",
    "data-name": "Point Machine",
    transform: "translate(1.526 0.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM132",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(488.811 308.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM132Hr",
    transform: "translate(35.278 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM132Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM132Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM132Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM132Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              132\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM131",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(459.351 337.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM131Hr",
    transform: "translate(-7.388 26.766) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM131Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM131Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM131Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM131Label",
    transform: "translate(2.482 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              131\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM114",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(920.018 585.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM114Hr",
    transform: "translate(-6.722 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM114Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM114Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM114Icon",
    transform: "translate(2.814 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM114Label",
    transform: "translate(2.456 21.388)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              114\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM136",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(708.052 157.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM136Hr",
    transform: "translate(35.278 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM136Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM136Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM136Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM136Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              136\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM135",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(652.384 196.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM135Hr",
    transform: "translate(-7.388 26.766) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM135Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM135Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM135Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM135Label",
    transform: "translate(2.482 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              135\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM106",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(926.052 162.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM106Hr",
    transform: "translate(9.946 26.146) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM106Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM106Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM106Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM106Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              106\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM105",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1012.518 193.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM105Hr",
    transform: "translate(19.278 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM105Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM105Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM105Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM105Label",
    transform: "translate(1.482 22.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              105\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM134",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(614.457 224.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM134Hr",
    transform: "translate(35.278 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM134Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM134Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM134Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM134Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              134\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM133",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(520.384 275.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM133Hr",
    transform: "translate(-7.388 26.766) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM133Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM133Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM133Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM133Label",
    transform: "translate(2.482 21.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              133\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM104",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1196.052 224.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM104Hr",
    transform: "translate(9.946 26.146) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM104Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM104Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM104Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM104Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              104\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM103",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1278.518 277.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM103Hr",
    transform: "translate(19.278 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM103Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM103Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM103Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM103Label",
    transform: "translate(1.482 22.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              103\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM102",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1279.516 308.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM102Hr",
    transform: "translate(9.946 26.146) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM102Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM102Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM102Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM102Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              102\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM101",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1391.518 336.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM101Hr",
    transform: "translate(19.278 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM101Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM101Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM101Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM101Label",
    transform: "translate(1.482 22.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              101\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM108",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(954.24 401.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM108Hr",
    transform: "translate(-6.722 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM108Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM108Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM108Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM108Label",
    transform: "translate(1.482 22.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              108\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM107",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(985.052 368.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM107Hr",
    transform: "translate(35.946 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM107Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM107Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM107Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM107Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              107\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM115",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(926.24 432.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM115Hr",
    transform: "translate(35.946 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM115Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM115Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM115Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM115Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              115\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM116",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(876.24 466.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM116Hr",
    transform: "translate(-6.722 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM116Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM116Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM116Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM116Label",
    transform: "translate(1.482 22.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              116\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM137",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(463.386 368.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM137Hr",
    transform: "translate(9.946 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM137Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM137Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM137Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM137Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              137\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM138",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(568.548 399.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM138Hr",
    transform: "translate(18.278 27.766) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM138Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM138Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM138Icon",
    transform: "translate(2.482 26.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM138Label",
    transform: "translate(3.482 23.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              138\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM111",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1038.262 433.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM111Hr",
    transform: "translate(35.946 25.019) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM111Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM111Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM111Icon",
    transform: "translate(20.482 22.9)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM111Label",
    transform: "translate(19.482 46.9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              111\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "PM113",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(956.239 522.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM113Hr",
    transform: "translate(-6.722 26.266) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM113Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    transform: "translate(0.199 1.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM113Hr2",
    d: "M0,1.239H0l2.707.014L3.082.012l1.69,2.663L5.39,1.124l3.331.116",
    transform: "translate(0.499 3.194)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM113Icon",
    transform: "translate(3.482 24.146)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM113Label",
    transform: "translate(1.482 22.146)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              113\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Shunt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGSH22",
    className: "tooltip cursorArrow ",
    transform: "translate(826 597.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-4",
    "data-name": "Pole",
    transform: "translate(0 19.834)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH22Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH22Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH22Label",
    transform: "translate(-0.76 10)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-22")), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(4.601 7.067)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH22Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.156 14.768) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH22Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.156 20.799) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH22Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.24 17.783) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH20",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(831 534.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-3",
    "data-name": "Pole",
    transform: "translate(0 19.834)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole1-2",
    "data-name": "SH18Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole2-2",
    "data-name": "SH18Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH20Label",
    transform: "translate(0 9)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-20")), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 6.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH20Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.701 14.768) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH20Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.701 20.799) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH20Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.785 17.783) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH7",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1425.73 323.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-10",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH17Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH7Label",
    transform: "translate(21.784 40.417)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-7")), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.871 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH7Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 14.618) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH7Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 20.649) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH7Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 16.649) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH16",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(859.127 142.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-9",
    "data-name": "Pole",
    transform: "translate(0 19.558)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH16Label",
    transform: "translate(-6.033 9)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-16")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 7.903)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH16Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 15.88) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH16Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 21.88) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH16Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(16.036 18.88) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH9",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1242.73 448.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-11",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-2",
    "data-name": "SH7Pole1",
    y1: 24.738,
    x2: 0.059,
    transform: "translate(6 -17.098)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SHPole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH9Label",
    transform: "translate(21.784 43.49)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-9")), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.872 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH9Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 14.618) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH9Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 20.649) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH9Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(25.379 16.649) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH37",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(770.255 239.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-8",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH37Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH37Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH37Label",
    transform: "translate(15.784 38.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-37")), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 4.469)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH37Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(30.379 12.407) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH37Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(30.379 18.438) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH37Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(23.379 14.438) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH39",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(610.54 448.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-7",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH39Label",
    transform: "translate(19.376 39.438)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-39")), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(21.147 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH39Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH39Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH39Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH41",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(777.657 170.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-12",
    "data-name": "Pole",
    transform: "translate(39.784 20.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole1-2",
    "data-name": "SH41Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716 -12.836)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole2-2",
    "data-name": "SH41Pole2",
    y1: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH41Label",
    transform: "translate(21.334 41.433)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-41")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(20.422 7.277)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH41Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 15.407) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH41Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(31.379 21.438) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH41Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(24.379 17.438) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH14",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(869.604 204.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole",
    transform: "translate(0 19.558)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH14Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH14Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH14Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-14")), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 7.875)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH14Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.156 15.851) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH14Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.156 21.882) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH14Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(16.24 18.867) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH18",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(823 478.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-2",
    "data-name": "Pole",
    transform: "translate(0 19.558)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH18Label",
    transform: "translate(0.24 10)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-18")), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 7.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH18Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 15.768) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH18Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 21.799) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH18Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.12 18.783) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH44",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(343.851 347.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-6",
    "data-name": "Pole",
    transform: "translate(0 19.558)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH44Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH44Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH44Label",
    transform: "translate(-1.273 9)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-44")), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(4.087 6.791)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH44Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.036 14.88) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH44Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.036 20.911) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH44Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.12 17.895) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSH12",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1018.84 289.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-5",
    "data-name": "Pole",
    transform: "translate(0 19.558)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH12Pole1",
    y1: 14.719,
    transform: "translate(0 0.942)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH12Pole2",
    y2: 5,
    transform: "translate(0 1.223) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH12Label",
    transform: "translate(-3.847 10.071)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-12")), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 6.791)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH12Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.156 14.768) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH12Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.156 20.799) rotate(-0.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH12Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.24 17.783) rotate(-0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGC3",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1550.264 384.573) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC3Label",
    transform: "translate(7.801 22.9)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n              C-3\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC3Aspect",
    transform: "translate(21.919 10.535)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES",
    transform: "translate(2.25 -0.988)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1",
    y2: 16.333,
    transform: "translate(39.283 0.133)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2",
    x2: 10,
    transform: "translate(29.198 16.413)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3",
    x2: 5,
    transform: "translate(14.697 16.363)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC46",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(339.995 323.514) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC46Label",
    transform: "translate(41.109 35.552) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\n              C-46\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGC46Aspect",
    transform: "translate(19.143 11.437)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 5,
    ry: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 4.25,
    ry: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-2",
    "data-name": "POLES",
    transform: "translate(9.146 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-2",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(24.585 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-2",
    "data-name": "POLES2",
    x2: 5,
    transform: "translate(19.5 16.358)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-2",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(8 16.309)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Signal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS47",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(293.011 383.978) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS47Label",
    transform: "translate(48.926 24.099) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-47\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS47Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS47Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-3",
    "data-name": "POLES",
    transform: "translate(51.42 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-3",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972 0)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-3",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS41",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(800.174 148.469) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS41Label",
    transform: "translate(5.912 4.959)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-41\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS41Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS41Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS14",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(909.427 210.776) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS14Label",
    transform: "translate(7.907 5.97)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-14\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS37",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(745.203 240.463) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS37Label",
    transform: "translate(5.004 33.069)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-37\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS46",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(374.317 322.317) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS46Label",
    transform: "translate(48.048 23.095) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-46\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect2",
    transform: "translate(22.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect1",
    transform: "translate(37.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS12",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1058.663 295.535) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS12Label",
    transform: "translate(7.907 5.97)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-12\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS2",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1556.011 324.205) rotate(179.7)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS2Label",
    transform: "translate(49.92 25) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-2\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS2pect2",
    transform: "translate(22.078 6.926)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS2Aspect1",
    transform: "translate(37.156 7.004)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-4",
    "data-name": "POLES",
    transform: "translate(51.42 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-4",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-4",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS3",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(1529.356 396.039) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS3Label",
    transform: "translate(6.596 23.428)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-3\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect2",
    transform: "translate(7.753 -3.65)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect1",
    transform: "translate(22.753 -3.572)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS39",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(585.414 448.699) rotate(-0.3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS39Label",
    transform: "translate(5.004 33.069)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              S-39\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "SGS39Aspect2",
    transform: "translate(0 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS39Aspect1",
    transform: "translate(15.078 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 7.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.5,
    rx: 6.75,
    ry: 6.75,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit",
    "data-name": "Track Circuit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TCC46T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC46TLine",
    x2: 167,
    transform: "translate(129.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC46TLabel",
    transform: "translate(198 335)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38.519,
    y: 0
  }, "\n              C46T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC46T1T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC46T1TLine",
    x2: 52,
    transform: "translate(299.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC46T1TLabel",
    transform: "translate(311 335)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              46T1T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC46T2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC46T2TLine",
    x2: 84,
    transform: "translate(354.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC46T2TLabel",
    transform: "translate(394 335)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              46T2T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC132T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC132TLine",
    x2: 80,
    transform: "translate(441.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC132TLabel",
    transform: "translate(479 335)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              132T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC133T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC133TLine",
    x2: 67,
    transform: "translate(524.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC133TLabel",
    transform: "translate(558 335)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              133T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOC2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOC2TLine",
    x2: 224,
    transform: "translate(594.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOC2TLabel",
    transform: "translate(717 320)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.941,
    y: 0
  }, "\n              OC2T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOC1T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOC1TLine",
    x2: 294,
    transform: "translate(821.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC0OC1TLabel",
    transform: "translate(976 320)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.941,
    y: 0
  }, "\n              OC1T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC103T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC103TLine",
    x2: 181,
    transform: "translate(1118.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC103TLabel",
    transform: "translate(1207 320)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              103T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC102T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC102TLine",
    x2: 82,
    transform: "translate(1302.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC102TLabel",
    transform: "translate(1324 320)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.908,
    y: 0
  }, "\n              102T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2TLine",
    x2: 312,
    transform: "translate(1486.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2TLabel",
    transform: "translate(1637 320)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.188,
    y: 0
  }, "\n              2T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC2AT",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2ATLine",
    x2: 96,
    transform: "translate(1387.5 323.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2ATLabel",
    transform: "translate(1437 320)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.668,
    y: 0
  }, "\n              2AT\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC47T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC47TLine",
    x2: 150,
    transform: "translate(129.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC47TLabel",
    transform: "translate(207 381)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.332,
    y: 0
  }, "\n              47T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC47AT",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC47ATLine",
    x2: 84,
    transform: "translate(282.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC47ATLabel",
    transform: "translate(316 381)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.813,
    y: 0
  }, "\n              47AT\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC131T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC131TLine",
    x2: 109,
    transform: "translate(369.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC131TLabel",
    transform: "translate(417 394)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              131T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC137T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC137TLine",
    x2: 82,
    transform: "translate(481.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC137TLabel",
    transform: "translate(515 380)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.192,
    y: 0
  }, "\n              137T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOA2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOA2TLine",
    x2: 264,
    transform: "translate(566.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOA2TLabel",
    transform: "translate(671 395)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.951,
    y: 0
  }, "\n              OA2T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOA1T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOA1TLine",
    x2: 168,
    transform: "translate(833.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOA1TLabel",
    transform: "translate(912 395)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.951,
    y: 0
  }, "\n              OA1T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC107T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC107TLine",
    x2: 265,
    transform: "translate(1004.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC107TLabel",
    transform: "translate(1117 380)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.621,
    y: 0
  }, "\n              107T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC101T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC101TLine",
    x2: 139,
    transform: "translate(1272.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC101TLabel",
    transform: "translate(1341 396)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              101T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T2",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3T2Line",
    x2: 83,
    transform: "translate(1414.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3T2Label",
    transform: "translate(1436 378)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.905,
    y: 0
  }, "\n              3T2\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T1",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3T1Line",
    x2: 68,
    transform: "translate(1500.5 383.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3T1Label",
    transform: "translate(1531 380)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.332,
    y: 0
  }, "\n              3T1\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCC3T",
    className: "tooltip cursorArrow ",
    title: "",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC3TLine",
    x2: 231,
    transform: "translate(1571.5 382.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC3TLabel",
    transform: "translate(1685 379)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.657,
    y: 0
  }, "\n              C3T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC138T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC138TLine",
    x2: 123,
    transform: "translate(468.5 448.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC138TLabel",
    transform: "translate(530 461)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              138T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOB2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOB2TLine",
    x2: 167,
    transform: "translate(594.5 448.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOB2TLabel",
    transform: "translate(665 445)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.893,
    y: 0
  }, "\n              OB2T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOB1T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOB1TLine",
    x2: 95,
    transform: "translate(764.5 448.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOB1TLabel",
    transform: "translate(799 445)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.036,
    y: 0
  }, "\n              OB1T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC115T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC115TLine",
    "data-name": "TC115TLine",
    x2: 95,
    transform: "translate(862.5 448.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC115TLabel",
    "data-name": "TC115TLabel",
    transform: "translate(872 446)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              115T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC108T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC108TLine",
    x2: 95,
    transform: "translate(960.5 448.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC108TLabel",
    transform: "translate(996 461)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              108T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC109_111T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC109_111TLine",
    x2: 282,
    transform: "translate(1058.5 448.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC109_111TLabel",
    transform: "translate(1174 461)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.931,
    y: 0
  }, "\n              109/111T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC112_113_114T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC112_113_114TLine",
    x2: 199,
    transform: "translate(776.5 570.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC112_113_114TLabel",
    transform: "translate(853 583)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35.385,
    y: 0
  }, "\n              112/113/114T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOE1T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOE1TLine",
    x2: 125,
    y2: 0.5,
    transform: "translate(834.5 177.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOE1TLabel",
    transform: "translate(906 189)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.53,
    y: 0
  }, "\n              OE1T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOE2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOE2TLine",
    x2: 83,
    transform: "translate(748.5 177.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOE2TLabel",
    transform: "translate(784 189)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.532,
    y: 0
  }, "\n              OE2T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC134T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC134TLine",
    x2: 97,
    transform: "translate(552.5 239.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC134TLabel",
    transform: "translate(597 236)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              134T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC135T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC135TLine",
    x2: 54,
    transform: "translate(678.5 239.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC135TLabel",
    transform: "translate(721 235)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.931,
    y: 0
  }, "\n              135T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOD2T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCOD2TLabel",
    transform: "translate(788 236)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.767,
    y: 0
  }, "\n              OD2T\n            ")), /*#__PURE__*/React.createElement("line", {
    id: "TCOD2TLine",
    x2: 124,
    transform: "translate(735.5 239.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "TCOD1T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOD1TLine",
    x2: 152,
    transform: "translate(862.5 239.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOD1TLabel",
    transform: "translate(941 252)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.48,
    y: 0
  }, "\n              OD1T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC105T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC105TLine",
    x2: 154,
    transform: "translate(1016.5 239.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC105TLabel",
    transform: "translate(1111 252)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.931,
    y: 0
  }, "\n              105T\n            "))), /*#__PURE__*/React.createElement("g", {
    id: "TC104T",
    className: "tooltip cursorArrow ",
    title: ""
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC104TLine",
    x2: 83,
    transform: "translate(1173.5 239.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC104TLabel",
    transform: "translate(1213 236)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.477,
    y: 0
  }, "\n              104T\n            ")))), /*#__PURE__*/React.createElement("g", {
    id: "Poles-5",
    "data-name": "Poles"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES",
    y1: 10,
    transform: "translate(553 234.096)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-2",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(129.5 318.096)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-3",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(129.5 378.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-4",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(469.5 443.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-5",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(776.5 565.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-6",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1802.5 378.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-7",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1799.5 318.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-8",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1256.5 234.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-9",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1341.5 443.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 119,
    transform: "translate(776.5 512.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 162,
    transform: "translate(776.5 632.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-10",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(896.5 508.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-11",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(776.5 627.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-12",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(776.5 507.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stationinfo",
    transform: "translate(-4332.808 30)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "StationInfoenglish",
    transform: "translate(5260.808 22)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "NirmalaUI, Nirmala UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -67.742,
    y: 0
  }, "\n            \u0906\u0932\u093F\u092A\u0941\u0930\u0926\u094D\u0935\u093E\u0930\n          ")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H180",
    transform: "translate(5170.808 39.216)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "StationInfo-2",
    "data-name": "StationInfo",
    transform: "translate(5260.808 80.431)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -103.645,
    y: 0
  }, "\n            New Alipurduar\n          "))), /*#__PURE__*/React.createElement("g", {
    id: "Legend",
    transform: "translate(-113.45 399.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegend",
    transform: "translate(1181 -730.028)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PMLegendLabel",
    transform: "translate(227 974)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              POINT MACHINE\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormal",
    transform: "translate(227 979.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormalIndicator",
    transform: "translate(0 0.232)",
    fill: "none",
    stroke: "#21e074",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendNormalLabel",
    transform: "translate(32 16.232)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                NORMAL\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverse",
    transform: "translate(227 1003.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverseIndicator",
    transform: "translate(0 0.416)",
    fill: "none",
    stroke: "#0088d1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendReverseLabel",
    transform: "translate(30 15.416)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                REVERSE\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendHr",
    transform: "translate(227.929 1024.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr1",
    d: "M10.433,19.646C4.823,15.724,1.881,12.155.675,9.168c-3.232-8,6-11.832,9.758-7.107,3.758-4.725,12.991-.9,9.758,7.107C18.985,12.155,16.043,15.724,10.433,19.646Z",
    transform: "translate(0 3.457)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr2",
    d: "M-.094.01H5.175L7.357-3.307l2.832,6.271L12.232.01,19.327,0",
    transform: "translate(0.807 12.769)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendFailureLabel",
    transform: "translate(28.702 15)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FAILURE\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendCanvas",
    transform: "translate(216 955)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 124,
    height: 107,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegend",
    transform: "translate(702 -788.03)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCLegendLabel",
    transform: "translate(898 1032)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n              TRACK CIRCUIT\n            ")), /*#__PURE__*/React.createElement("g", {
    id: "TCFreeLegendGroup",
    transform: "translate(888.5 1040.52)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFreeLegendIndicator",
    x2: 70,
    transform: "translate(-2 10.474)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFreeLegendLabel",
    transform: "translate(75.5 15.974)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FREE\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "TCOccupiedLegendGroup",
    transform: "translate(897.5 1061.093)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOccupiedLegendIndicator",
    x2: 70,
    transform: "translate(-11 12.846)",
    fill: "none",
    stroke: "#e77e00",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOccupiedLegendLabel",
    transform: "translate(65.921 18.346)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                OCCUPIED\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "TCFailureLLegendGroup",
    transform: "translate(897.5 1083.744)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFailureLegendIndicator",
    x2: 70,
    transform: "translate(-11 11.296)",
    fill: "none",
    stroke: "red",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFailureLLegendLabel",
    transform: "translate(68 16.796)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\n                FAILURE\n              "))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegendCanvas",
    transform: "translate(876 1013)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 157,
    height: 107,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "LCG",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89AContent"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LOCK",
    transform: "translate(1257 122)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.17,
    y: 0
  }, "LOCK")), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN89Line",
    x1: 3,
    y2: 308,
    transform: "translate(1208 184.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "LCGNN89TLabel",
    transform: "translate(1192 138)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.344,
    y: 0
  }, "CONTROL 301"), /*#__PURE__*/React.createElement("tspan", {
    x: -46.17,
    y: 15
  }, "GATE NO. NN-89A")), /*#__PURE__*/React.createElement("text", {
    id: "LCGNN90ALabel-2",
    "data-name": "LCGNN90ALabel",
    transform: "translate(1192 511)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.344,
    y: 0
  }, "CONTROL 302"), /*#__PURE__*/React.createElement("tspan", {
    x: -46.253,
    y: 15
  }, "GATE NO. NN-89B")), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN89Line-2",
    "data-name": "LCGNN89Line",
    x1: 3,
    y2: 308,
    transform: "translate(1171.5 184.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(1144 124)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 56,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 96,
    height: 54,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CHR",
    transform: "translate(1305 122)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.947,
    y: 0
  }, "CHR")), /*#__PURE__*/React.createElement("text", {
    id: "EMRSR",
    transform: "translate(1282 122)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.977,
    y: 0
  }, "EMRSR"))), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89BoomAClose",
    transform: "translate(1157 170)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89BoomAOpen",
    transform: "translate(1188 170)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89EMRSR",
    transform: "translate(1271 126)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89CHR",
    transform: "translate(1293 126)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89LOCK",
    transform: "translate(1249 126)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89BoomBClose",
    transform: "translate(1161 537)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89BoomBOpen",
    transform: "translate(1195 537)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90LOCK",
    transform: "translate(472 208)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90BoomBClose",
    transform: "translate(373 470)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90BoomBOpen",
    transform: "translate(410 469)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90EMRSR",
    transform: "translate(494 208)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), "AO\n          ", /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90CHR",
    transform: "translate(516 208)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90BoomAClose",
    transform: "translate(376 252)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90BoomAOpen",
    transform: "translate(411 252)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90AContent"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LCGNN90Label",
    transform: "translate(412 220)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.344,
    y: 0
  }, "CONTROL 302"), /*#__PURE__*/React.createElement("tspan", {
    x: -46.17,
    y: 15
  }, "GATE NO. NN-90A")), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN90Line",
    y2: 165,
    transform: "translate(407 262)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(359 208)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 54,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    transform: "translate(356 426)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 54,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "LCGNN90ALabel",
    transform: "translate(403 438)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.344,
    y: 0
  }, "CONTROL 302"), /*#__PURE__*/React.createElement("tspan", {
    x: -46.253,
    y: 15
  }, "GATE NO. NN-90B")), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN90ALine",
    y2: 164.5,
    transform: "translate(428.5 262)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    transform: "translate(1137 493)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 54,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CHR-2",
    "data-name": "CHR",
    transform: "translate(526 206)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.947,
    y: 0
  }, "CHR")), /*#__PURE__*/React.createElement("text", {
    id: "EMRSR-2",
    "data-name": "EMRSR",
    transform: "translate(503 206)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.977,
    y: 0
  }, "EMRSR")))), /*#__PURE__*/React.createElement("g", {
    id: "LCGContent"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CLOSED",
    transform: "translate(380 251)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.051,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN",
    transform: "translate(415 251)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.764,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED-2",
    "data-name": "CLOSED",
    transform: "translate(1162 165)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.051,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN-2",
    "data-name": "OPEN",
    transform: "translate(1192 165)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.764,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    id: "LOCK-2",
    "data-name": "LOCK",
    transform: "translate(478 206)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.17,
    y: 0
  }, "LOCK")), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED-3",
    "data-name": "CLOSED",
    transform: "translate(380 465)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.051,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN-3",
    "data-name": "OPEN",
    transform: "translate(415 465)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.764,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED-4",
    "data-name": "CLOSED",
    transform: "translate(1165 536)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.051,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN-4",
    "data-name": "OPEN",
    transform: "translate(1200 536)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.764,
    y: 0
  }, "OPEN")))), /*#__PURE__*/React.createElement("g", {
    id: "AXL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_DN1",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_DN1Label",
    transform: "translate(1336 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.495,
    y: 0
  }, "NBS_DN1")), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_DN1Icon",
    transform: "translate(1330 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_DN2",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_DN2Label",
    transform: "translate(1392 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.495,
    y: 0
  }, "NBS_DN2")), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_DN2Icon",
    transform: "translate(1384 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_UP1",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_UP1Label",
    transform: "translate(1446 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.654,
    y: 0
  }, "NBS_UP1")), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_UP1Icon",
    transform: "translate(1439 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_UP2",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_UP2Label",
    transform: "translate(1501 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.654,
    y: 0
  }, "NBS_UP2")), /*#__PURE__*/React.createElement("g", {
    id: "ACNBS_UP2Icon",
    transform: "translate(1495 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_DN1",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLSMTA_DN1Label",
    transform: "translate(1560 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.273,
    y: 0
  }, "SMTA_DN1")), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_DN1Icon",
    transform: "translate(1546 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_DN2",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLSMTA_DN2Label",
    transform: "translate(1623 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.273,
    y: 0
  }, "SMTA_DN2")), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_DN2Icon",
    transform: "translate(1606 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_UP1",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLSMTA_UP1Label",
    transform: "translate(1685 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.433,
    y: 0
  }, "SMTA_UP1")), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_UP1Icon",
    transform: "translate(1666 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_UP2",
    className: "tooltip",
    title: ""
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXSMTA_UP2Label",
    transform: "translate(1747 581)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.433,
    y: 0
  }, "SMTA_UP2")), /*#__PURE__*/React.createElement("g", {
    id: "ACSMTA_UP2Icon",
    transform: "translate(1728 552)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "AXLE_COUNTER",
    "data-name": "AXLE COUNTER",
    transform: "translate(1534 537)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64.477,
    y: 0
  }, "AXLE COUNTER")), /*#__PURE__*/React.createElement("g", {
    id: "AXLRectangle",
    transform: "translate(1307 507)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 483,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 480,
    height: 106,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "GHY_END",
    "data-name": "GHY END",
    transform: "translate(150 246)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.247,
    y: 0
  }, "GHY END")), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M26.084-5.689v2.731L6.169-3.047V2.375L-9.124-6.357l.4-.189L-7.6-7l.8-.325",
    transform: "translate(77.857 244.515)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "NBS_END",
    "data-name": "NBS END",
    transform: "translate(1688 246)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.495,
    y: 0
  }, "NBS END")), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M-9.124.737V-1.994l19.915.089V-7.328L26.084,1.4l-.4.189-1.118.456-.8.325",
    transform: "translate(1745.868 238.125)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bitcomm_logo-2",
    "data-name": "Bitcomm_logo",
    transform: "translate(20 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(35.597 0.608) rotate(45)",
    fill: "#0e86d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.90496444702148 50.90496444702148 L 1.887659072875977 49.62485504150391 L 0.6075512766838074 0.6075512766838074 L 49.62485504150391 1.887659072875977 L 50.90496444702148 50.90496444702148 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.121135711669922 1.121135711669922 L 2.375099182128906 49.13741683959961 L 50.39138031005859 50.39138031005859 L 49.13741683959961 2.375099182128906 L 1.121135711669922 1.121135711669922 M 0.09396743774414062 0.09396743774414062 L 50.11229705810547 1.400218963623047 L 51.41854858398438 51.41854858398438 L 1.400218963623047 50.11229705810547 L 0.09396743774414062 0.09396743774414062 Z",
    stroke: "none",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.204 19.74)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 17.799,
    ry: 18.753,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 15.299,
    ry: 16.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M.568-1.031h0s8.95,7.449,10.283,9.924a47.609,47.609,0,0,1,2.316,5.086",
    transform: "translate(9.332 30.117)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(16.001 22.307) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M.143,5.135.455.013l14.3.812,2.286,4.348L15.152,5.2Z",
    transform: "translate(0.54 0.509)",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1.448,1.027,1.2,5.165l14.469.058L16.8,5.209,15,1.8,1.448,1.027M.542.015,15.58.869l2.778,5.284-2.639.033L.171,6.123Z",
    transform: "translate(0 0)",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 7.56, 30.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M3.893.459-.014.5,0,0,3.893.366Z",
    transform: "translate(0.473 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M.013,0,4.85.455v1l-4.892.051Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M44,44",
    transform: "translate(-3.719 31.506)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 1.481)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 31.584)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 26.649)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(9.368 21.714)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(69.789) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571 0)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-2",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(70.258 73.532) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 27.636)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-3",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(8.431 22.701)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-3",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-3",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(34.192 37.506) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-4",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-4",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-4",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-4",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571 0)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-4",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoqStation);
export default __webpack_public_path__ + "static/media/NOQ_Station.b6f603918000d64174157766e2c8e42b.svg";
export { ForwardRef as ReactComponent };